<label class="search-input">
  <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>

  <input
    type="search"
    [value]="value()"
    [placeholder]="placeholder()"
    (input)="onInput($event)"
    aria-label="Campo de búsqueda"
  />
</label>
